import * as _ from 'lodash';

import { formatOrdinals } from '../utils';

/**
 * Takes an EPSS score + percentile and returns a human-readable
 * label (which displays the score and percentile rank) as well as
 * a more detailed explanation (for tooltips, mainly).
 *
 * The label format is based on the official guidance described here:
 * https://www.first.org/epss/articles/prob_percentile_bins
 */
export const getHumanReadableEPSSFields = (percentileVal?: number, scoreVal?: number) => {
  if (_.isNil(percentileVal) || _.isNil(scoreVal)) {
    return { percentile: 'Unknown', score: 'Unknown', label: 'Unknown' };
  }

  // round score to a percentage value with one decimal digit
  const formattedScore = (scoreVal * 100).toFixed(1);
  const score = `${formattedScore}%`;

  const percentile = formatOrdinals(Math.round(percentileVal * 100));

  const label = `${score} (${percentile})`;

  return { percentile, score, label };
};
